import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=c078473e&scoped=true"
import script from "./collections.vue?vue&type=script&lang=js"
export * from "./collections.vue?vue&type=script&lang=js"
import style0 from "./collections.vue?vue&type=style&index=0&id=c078473e&prod&scoped=true&lang=css"
import style1 from "./collections.vue?vue&type=style&index=1&id=c078473e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c078473e",
  null
  
)

export default component.exports